export default {
    // 流程递转
    toOtherPer(params, response) {
        window.vue.$apiAxios.postRequestBody('/activitiDemo/toOtherPer', params, response);
    },
    // 完成任务
    completeOrRefuse(params, response) {
        window.vue.$apiAxios.postRequestBody('/activitiDemo/completeOrRefuse', params, response);
    },
    // 流程运行中的任务信息
    findTask(params, response) {
        window.vue.$apiAxios.postRequestBody('/WorkFlowProcessQuery/findTask', params, response);
    },
    // 查询运行中的流程信息
    findProIns(params, response) {
        window.vue.$apiAxios.postRequestBody('/activitiDemo/findProIns', params, response);
    },
    // 查询历史流程信息
    findHisProcess(params, response) {
        window.vue.$apiAxios.postRequestBody('/WorkFlowProcessQuery/findHisProcess', params, response);
    },
    // 查询历史任务信息
    findHisTask(params, response) {
        window.vue.$apiAxios.postRequestBody('/WorkFlowProcessQuery/findHisTask', params, response);
    },
    // 流程拒绝
    reject(params, response) {
        window.vue.$apiAxios.postRequestBody('/activitiDemo/reject', params, response);
    },
    // 查询流程信息
    queryLeaveBillByCode(params, response) {
        return window.vue.$apiAxios.postRequestBody('/WorkFlowDemoController/queryLeaveBillByCode', params, response);
    },
    // 启动流程模板生成流程
    startModel(params, response) {
        window.vue.$apiAxios.get('/WorkFlowProcessQuery/startModel', params, response);
    },
    // 模板信息查询接口
    queryTemplate(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/queryTemplate', params, response);
    },
    // 删除流程
    deleteProIns(params, response) {
        window.vue.$apiAxios.get('/WorkFlowProcessQuery/deleteProIns', params, response);
    },
    //自建表格查询数据
    selfBuildTableSelect(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/selfBuildTableSelect', params, response);
    },
    // 查询字典表信息接口
    getDictValuesByType(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/dictController/getDictValuesByType', params, response);
    }
};
